import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2">
            <span className={`text-xl font-bold ${isScrolled ? 'text-[#003366]' : 'text-[#003366]'}`}>
              クレカ比較ナビ
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-6">
            <Link to="/ranking" className={`text-sm font-medium hover:text-[#0099CC] transition-colors ${isScrolled ? 'text-gray-700' : 'text-gray-700'}`}>
              ランキング
            </Link>
            <Link to="/comparison" className={`text-sm font-medium hover:text-[#0099CC] transition-colors ${isScrolled ? 'text-gray-700' : 'text-gray-700'}`}>
              カード比較
            </Link>
            <Link to="/free" className={`text-sm font-medium hover:text-[#0099CC] transition-colors ${isScrolled ? 'text-gray-700' : 'text-gray-700'}`}>
              年会費無料
            </Link>
            <a
              href="https://px.a8.net/svt/ejp?a8mat=4AXB0E+3PYKNU+4T5W+5YRHE"
              rel="nofollow"
              target="_blank"
              className="bg-[#0099CC] hover:bg-[#007AA3] text-white text-sm font-bold px-4 py-2 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
            >
              公式サイト
            </a>
            <img 
              border="0" 
              width="1" 
              height="1" 
              src="https://www19.a8.net/0.gif?a8mat=4AXB0E+3PYKNU+4T5W+5YRHE" 
              alt=""
              style={{ display: 'none' }}
            />
          </nav>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl text-gray-700`}></i>
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-100 py-4">
            <nav className="flex flex-col gap-4">
              <Link to="/ranking" className="text-gray-700 text-sm font-medium px-4 py-2 hover:bg-gray-50">
                ランキング
              </Link>
              <Link to="/comparison" className="text-gray-700 text-sm font-medium px-4 py-2 hover:bg-gray-50">
                カード比較
              </Link>
              <Link to="/free" className="text-gray-700 text-sm font-medium px-4 py-2 hover:bg-gray-50">
                年会費無料
              </Link>
              <a
                href="https://px.a8.net/svt/ejp?a8mat=4AXB0E+3PYKNU+4T5W+5YRHE"
                rel="nofollow"
                target="_blank"
                className="mx-4 bg-[#0099CC] hover:bg-[#007AA3] text-white text-sm font-bold px-4 py-2 rounded-lg text-center"
              >
                公式サイト
              </a>
              <img 
                border="0" 
                width="1" 
                height="1" 
                src="https://www19.a8.net/0.gif?a8mat=4AXB0E+3PYKNU+4T5W+5YRHE" 
                alt=""
                style={{ display: 'none' }}
              />
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
